module.exports = __webpack_public_path__ + "img/Over mij - foto.2a2c9e3d.webp";